import { Button } from '@/components/ui/button'
import { ConfirmationDialog } from '@/components/ui/confirmation-dialog'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

interface RequestToBindButtonProps {
  /** Why binding has to wait, e.g. the customer hasn't confirmed their information. */
  blockedReason: string | null
  onConfirm: () => void | Promise<void>
}

export function RequestToBindButton({ blockedReason, onConfirm }: RequestToBindButtonProps) {
  if (blockedReason) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span tabIndex={0}>
            <Button size="sm" disabled aria-disabled="true">
              Request to bind
            </Button>
          </span>
        </TooltipTrigger>
        <TooltipContent>{blockedReason}</TooltipContent>
      </Tooltip>
    )
  }
  return (
    <ConfirmationDialog
      title="Request to bind"
      description="Are you sure you want to request to bind this coverage?"
      confirmLabel="Request to bind"
      onConfirm={onConfirm}
    >
      <Button size="sm">Request to bind</Button>
    </ConfirmationDialog>
  )
}
